<template>
  <div class="t-lk-course-rate" v-if="course">
    <div class="t-lk-course-rate__wrap">
      <h3 class="t-lk-course-rate__title">{{ $root.staticText.lk.materialsOnlineCoursesRateCourse }}</h3>
      <p class="t-lk-course-rate__desc">{{ $root.staticText.lk.materialsOnlineCoursesRateCourseDesc }}</p>
      <ul class="t-lk-course-rate__list">
        <li
          v-for="(star, index) in rating"
          :key="star.id"
          class="t-lk-course-rate__item"
          @mouseenter="setHoverCheck(index, true)"
          @mouseleave="setHoverCheck(index, false)"
          @click="toggleRating(index)"
        >
          <svg
            :class="{ _check: star.check, _hover: star.hover }"
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M16.0001 1.6001C16.4061 1.6001 16.7769 1.83057 16.9566 2.19463L20.8287 10.039L29.4877 11.3046C29.8894 11.3634 30.2229 11.645 30.3481 12.0311C30.4733 12.4172 30.3685 12.841 30.0777 13.1242L23.813 19.2261L25.2914 27.8465C25.3601 28.2467 25.1956 28.6511 24.867 28.8898C24.5385 29.1284 24.103 29.1598 23.7436 28.9708L16.0001 24.8986L8.25661 28.9708C7.89723 29.1598 7.46172 29.1284 7.13321 28.8898C6.8047 28.6511 6.64017 28.2467 6.70881 27.8465L8.1873 19.2261L1.92255 13.1242C1.63175 12.841 1.52693 12.4172 1.65213 12.0311C1.77734 11.645 2.11086 11.3634 2.51253 11.3046L11.1716 10.039L15.0436 2.19463C15.2233 1.83057 15.5941 1.6001 16.0001 1.6001Z"
              stroke="#C0C0CC"
              stroke-width="2px"
            />
          </svg>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'lk-course-rate',
  props: {
    course: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      rating: [
        {
          id: 1,
          check: false,
          hover: false,
        },
        {
          id: 2,
          check: false,
          hover: false,
        },
        {
          id: 3,
          check: false,
          hover: false,
        },
        {
          id: 4,
          check: false,
          hover: false,
        },
        {
          id: 5,
          check: false,
          hover: false,
        },
      ],
    }
  },
  methods: {
    setHoverCheck(index, value) {
      this.rating.forEach((item, i) => {
        if (i <= index) {
          item.hover = value
        }
      })
    },
    setCheck(index) {
      this.rating.forEach((item, i) => {
        item.check = i <= index
      })
    },
    toggleRating(index) {
      const rating = index + 1

      let fd = new FormData()
      fd.append('id', this.course.id)
      fd.append('rating', rating)

      Vue.http
        .post('lk/materials-online-courses/addRating', fd)
        .then(response => response.json())
        .then(data => {
          if (data.success) {
            this.setCheck(index)
          }
        })
        .catch(() => {})
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/templates/components/lk/lk-course/lk-course-rate/lk-course-rate.vue